// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2E4aE","modalForm":"UpgradeEpcsModal_modalForm__2Mcov","modalFooter":"UpgradeEpcsModal_modalFooter__6ojsT"};